<template>
  <div class="home-feature" :class="{'flip-container': isFlipped}">
    <section class="feature-content-container">
      <div>
        <h1>{{ title }}</h1>
        <!-- <img :src="require({imageSource})"  alt=""> -->
        <img :src="require(`@/assets/images/${imageSource}`)" alt="">
        <h2>{{ subtitle }}</h2>

        <p>{{ text }}</p>

        <s-button class="button-secondary" btn-link="/products">{{$t('actions.learn-more')}}</s-button>

      </div>
    </section>
    <section class="feature-video-container">
      <component :is="lottiePath" class="feature-video"/>
      <!-- <LottieSearch class="feature-video"/> -->
      <!-- lottie anim included in the div id bm -->
      <!-- <Lottie :options="animOpts" class="feature-video"  /> -->

      <!-- <div id="bm"></div> -->
      <!-- <lottie-animation
       path="@/anim/draganddrop/DragAndDrop_1080p.json"
       />   -->

      <!--      <video :poster="require(`@/assets/images/${videoPlaceholder}`)" autoplay="" loop="" style="" class="feature-video" muted="" playsinline="" data-wf-ignore="true" width="100%">-->
      <!--      </video>-->
    </section>
  </div>
</template>

<script>
import LottieSearch from '@/components/LottieSearch.vue'
import LottieDragAndDrop from '@/components/LottieDragAndDrop.vue'
import LottieAuto from '@/components/LottieAuto.vue'
import Vue3Lottie from 'vue3-lottie'
import SButton from "@/components/SButton.vue";

export default {
  name: 'HomeFeature',
  components: {
    SButton,
    LottieSearch,
    LottieDragAndDrop,
    LottieAuto,
    Vue3Lottie
  },
  props: {
    title: String,
    subtitle: String,
    text: String,
    imageSource: String,
    videoSource: String,
    videoPlaceholder: String,
    lottiePath: String,
    isFlipped: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style scoped lang="scss">

</style>
